import { ReactNode } from 'react';

export interface ReferralPageContainerProps {
  hero?: ReactNode;
  tabs?: ReactNode;
  children?: ReactNode;
}

const ReferralPageContainer = ({ hero, tabs, children }: ReferralPageContainerProps) => {
  return (
    <div className='border-decoration-stroke flex min-h-[calc(100vh-230px)] flex-col md:min-h-[calc(100vh-138px)] xl:mx-[23px] xl:border-x'>
      <div className='grid min-h-0 flex-1 grid-cols-1 content-start xl:grid-cols-[1fr_minmax(0,1244px)_1fr] xl:grid-rows-[auto_auto_1fr]'>
        <div className='border-decoration-stroke hidden xl:block min-[1310px]:border-r' />
        <div className='min-w-0'>{hero}</div>
        <div className='border-decoration-stroke hidden xl:block min-[1310px]:border-l' />

        <div className='border-decoration-stroke hidden border-b xl:block min-[1310px]:border-r' />
        <div className='border-decoration-stroke min-w-0 border-b px-5 md:px-10'>{tabs}</div>
        <div className='border-decoration-stroke hidden border-b xl:block min-[1310px]:border-l' />

        <div className='border-decoration-stroke hidden xl:block min-[1310px]:border-r' />
        <div className='min-w-0'>{children}</div>
        <div className='border-decoration-stroke hidden xl:block min-[1310px]:border-l' />
      </div>
    </div>
  );
};

export default ReferralPageContainer;
